import { getFrontendVersion } from '@repo/api';
import { queryKeys, useAppType } from '@repo/lib';
import { useQuery } from '@tanstack/react-query';

export const useVersionQuery = () => {
  const appType = useAppType();

  const { data } = useQuery({
    queryFn: () => getFrontendVersion(appType),
    queryKey: queryKeys.version.frontend,
    refetchInterval: 1000 * 60 * 5,
  });

  return data?.appVersion ?? '';
};
